import React from "react";

type Tab = {
    id: string;
    label: string;
    content: React.ReactNode;
};

type TabsProps = {
    tabs: Tab[];
    className?: string;
    setActiveTab: any;
    activeTab: any
};

export default function Tabs({ tabs, className, setActiveTab, activeTab }: TabsProps) {

    const handleTabClick = (id: string) => {
        setActiveTab(id);
    };

    return (
        <div className={`w-full ${className}`}>
            {/* Tabs Navigation */}
            <div className={`flex border-b gap-8 containerCustom`}>
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => handleTabClick(tab.id)}
                        className={`py-2 font-aeonikBold font-bold relative ${activeTab === tab.id
                            ? "text-primary  active-tab"
                            : "text-darkGrey hover:text-primary"
                            }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tabs Content */}
            <div className="mt-4 containerCustom">
                {tabs.map(
                    (tab) =>
                        activeTab === tab.id && (
                            <div key={tab.id} className="">
                                {tab.content}
                            </div>
                        )
                )}
            </div>
        </div>
    );
};